import React, { useContext, useEffect, useState } from 'react';
import { PeFilterContext } from '../../Contexts/PeFilterContext';
import MultiSelectEntity from '../RefineSearch/MultiSelectEntity';
import Popup from '../Common/Popup';

function DealsInvolvingFilter({ DealsInvolvingOptions, setDealsInvolvingOptions, customPathname, label = "Deals Involving", isPopupOpen, setIsPopupOpen }) {
    const { DealsInvolving, refineSearchFilters } = useContext(PeFilterContext);
    
    // Use internal state only if props are not provided (for backward compatibility)
    const [internalPopupOpen, setInternalPopupOpen] = useState(false);
    const popupOpen = isPopupOpen !== undefined ? isPopupOpen : internalPopupOpen;
    const setPopupOpen = setIsPopupOpen !== undefined ? setIsPopupOpen : setInternalPopupOpen;

    useEffect(() => {
        const industryIds = refineSearchFilters[customPathname]?.dealsInvolving?.map(value => value.id) ?? [];
        setDealsInvolvingOptions(DealsInvolving.map(deal => ({ ...deal, isChecked: industryIds.includes(deal.id) })));
    }, [DealsInvolving, customPathname, refineSearchFilters, setDealsInvolvingOptions]);

    const handleDealsInvolvingChange = (e) => {
        const { id, checked, name, filteredIds } = e.target;
        
        // Handle "Select All" / "Deselect All" functionality
        if (name === 'filteredSelect') {
            const updatedDeals = DealsInvolvingOptions.map(deal =>
                filteredIds.includes(deal.id) ? { ...deal, isChecked: checked } : deal
            );
            setDealsInvolvingOptions(updatedDeals);
        } else {
            // Handle individual checkbox changes
            const updatedDeals = DealsInvolvingOptions.map(deal =>
                deal.id === parseInt(id) ? { ...deal, isChecked: checked } : deal
            );
            setDealsInvolvingOptions(updatedDeals);
        }
    };

    const selectedDealsLength = DealsInvolvingOptions?.filter(option => option.isChecked)?.length ?? 0;

    return (
        <div className="relative w-full md:inline-block">
            <button
                type="button"
                className="h-10 rounded-md px-4 py-1 text-gray-500 hover:bg-gray-100  text-sm shadow-md border border-gray-300 text-left flex items-center justify-between w-full md:w-[90%]"
                onClick={() => setPopupOpen(!popupOpen)}
            >
                <span className="truncate pr-2">{label} <span className="opacity-60 ml-2 text-xs text-ellipsis">e.g. {DealsInvolvingOptions.slice(0,2).map(item => item.name).join(', ')}</span></span>
                <div className="flex items-center gap-2 flex-shrink-0">
                    {selectedDealsLength > 0 && (
                        <span className="bg-white rounded-full px-2 py-0.5 text-xs font-medium border border-gray-400">
                            {selectedDealsLength}
                        </span>
                    )}
                    <span className={`transition-transform duration-200 text-xl font-semibold ${popupOpen ? 'rotate-[270deg]' : 'rotate-90'}`}>
                        ›
                    </span>
                </div>
            </button>

            {popupOpen && (
                <Popup onClose={() => setPopupOpen(false)}>
                    <div className="p-4">
                        <MultiSelectEntity
                            handleEntityChange={handleDealsInvolvingChange}
                            primaryEntity={DealsInvolvingOptions}
                            showAll={false}
                            searchBox={false}
                        />
                    </div>
                </Popup>
            )}
        </div>
    );
}

export default DealsInvolvingFilter;